import { useContext } from "react";
import TargetsList from "features/signals/SignalDrawer/Targets/TargetsSection/TargetsList";
import { GetExchangeSignalByIdRequest } from "@shared/types";
import { EditSignalContext } from "features/signals/EditSignal/EditSignal.context";
import { OrdersWrapper } from "features/trades/TradeDrawer/Orders/styles";
import { OrderTypes } from "@shared/features/trades/common/types";

interface TargetsSectionProps {
  args: GetExchangeSignalByIdRequest;
  isEdit: boolean;
}

const TargetsSection = ({ args, isEdit }: TargetsSectionProps) => {
  const {
    entryTargets,
    takeProfitTargets,
    stopTargets,
    setEntryTargets,
    setTakeProfitTargets,
    setStopTargets,
  } = useContext(EditSignalContext)!;

  return (
    <OrdersWrapper>
      <TargetsList
        args={args}
        targets={entryTargets}
        targetType={OrderTypes.ENTRY}
        isEdit={isEdit}
        setTargets={setEntryTargets}
      />
      <TargetsList
        args={args}
        targets={takeProfitTargets}
        targetType={OrderTypes.TAKE_PROFIT}
        isEdit={isEdit}
        setTargets={setTakeProfitTargets}
      />
      <TargetsList
        args={args}
        targets={stopTargets}
        targetType={OrderTypes.STOP}
        isEdit={isEdit}
        setTargets={setStopTargets}
      />
    </OrdersWrapper>
  );
};

export default TargetsSection;
